var moment = require('js/lib/moment');

module.exports = function() {

  return function(routePlans, archive) {
    var today = moment().format('YYYY-MM-DD');

    if (routePlans === undefined) return [];

    return routePlans.filter(function(routePlan) {
      var isActive = routePlan.date >= today;
      return archive ? ! isActive : isActive;
    });
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/filters/activeRoutePlans.js
 ** module id = 160
 ** module chunks = 1
 **/